// PWA Configuration for Binntu Driver
export const pwaConfig = {
  name: 'Binntu Transport Driver',
  shortName: 'Binntu Driver',
  description: 'Aplicación para conductores de Binntu Transport',
  themeColor: '#10b981',
  backgroundColor: '#ffffff',
  display: 'standalone',
  orientation: 'portrait',
  scope: '/',
  startUrl: '/',
  icons: [
    {
      src: '/logo.png',
      sizes: '192x192',
      type: 'image/png',
      purpose: 'any maskable'
    },
    {
      src: '/logo.png',
      sizes: '512x512',
      type: 'image/png',
      purpose: 'any maskable'
    },
    {
      src: '/logo.png',
      sizes: '96x96',
      type: 'image/png',
      purpose: 'any'
    }
  ],
  appleTouchIcons: [
    {
      src: '/logo.png',
      sizes: '192x192'
    },
    {
      src: '/logo.png',
      sizes: '512x512'
    }
  ]
};

// Function to check if app is installed
export const isAppInstalled = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
};

// Function to show install prompt
export const showInstallPrompt = () => {
  if ('serviceWorker' in navigator && 'BeforeInstallPromptEvent' in window) {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      window.deferredPrompt = e;
      // You can show a custom install button here
      console.log('Install prompt ready');
    });
  }
};

// Function to install app
export const installApp = async () => {
  if (window.deferredPrompt) {
    window.deferredPrompt.prompt();
    const { outcome } = await window.deferredPrompt.userChoice;
    window.deferredPrompt = null;
    return outcome === 'accepted';
  }
  return false;
}; 